import axios from 'axios';
import { getSecureBaseUrl } from '../../services/UrlMapperService';
import { HttpService } from '../../services/HttpService';
import { apiUrls } from '../../constants/apiUrl';
import {
  getIntendType,
  getJointTransactionLine,
  isJointTransactionFlow,
  isWHWPhase2Flag,
  isWHWP2,
  viewport,
  getCookie,
  getSession,
} from '../../components/common/Helpers/index';
import * as Constants from './constants';

export const getAddons = (data) => ({
  type: 'GET_ADDONS',
  data,
});

export const fetchE911Address = () => HttpService.get(`${getSecureBaseUrl()}${apiUrls().addOnAddressurl}`);

export const setAddonsRef = (data) => ({
  type: Constants.SET_ADDON_REFERENCE,
  data,
});

export const e911Address = (data) => ({
  type: 'FETCH_E911ADDRESS',
  data,
});
export const confirmVisionPendingOrderapi = (visionData) => ({
  type: 'VISION_PENDING',
  visionData,
});

export const getNPANXXAPI = (data) => {
  // const postData={
  //   "state":"TX","city":"SAN ANTONIO","zipcode":"78218"
  // }
  const postData = data.data;
  const apiURL = `${getSecureBaseUrl()}${apiUrls().retreivenpanxx}`;
  return HttpService.post(apiURL, postData);
};

export const callNPANXX = (data) => ({
  type: 'GET_NPA_NXX',
  data,
});

export const updateAssignMtnStatus = (data) => ({
  type: 'UPDATE_MTN_STATUS',
  data,
});

export const getskipStatus = (data) => ({
  type: 'SKIP_STATUS',
  data,
});

export const setAddons = (data) => ({
  type: 'SET_ADDONS',
  data,
});

export const updateProcessStepAddons = (data, pageName) => ({
  type: 'UPDATE_PROCESS_STEP_ADDONS',
  data,
  pageName,
});

export const updateProcessStepApi = (obj, pageName) => {
  try {
    let postData = {};
    // let apiResponse = '';
    const processAction = obj?.data === 'continueBtn' ? 'Complete' : 'Skip';
    postData = {
      cartInfo: {
        clientAppName: 'VZW-DOTCOM',
        accountNumber: '',
        cartCreator: '',
        processingMTN: isJointTransactionFlow() ? `${getJointTransactionLine()}` : 'newLine1',
        processStep: pageName,
        processAction,
        intendType: `${getIntendType()}`,
        bundleInstallType: '',
      },
      data: {},
    };

    // apiResponse = HttpService.post(`${getSecureBaseUrl()}${apiUrls().updateProcessStepAddons}`, postData);
    // Promise.all([apiResponse]).then((res) => res);
    const apiURL = `${getSecureBaseUrl()}${apiUrls().updateProcessStepAddons}`;
    return HttpService.post(apiURL, postData);
  } catch (error) {
    console.log('Error in action.js', error);
  }
};

export const assignNPANXXMTN = (npanxx, ngp1, nonGeoLine = null) => {
  let postData = {};
  const joint = isJointTransactionFlow();
  const line = joint ? `${getJointTransactionLine()}` : 'newLine1';
  const intendType = `${getIntendType()}`;

  postData = intendType.includes('NSE')
    ? {
        cartInfo: {
          intendType: `${getIntendType()}`,
          processingMTN: line,
          processStep: 'Accessories',
          processAction: 'AssignNumbers',
          customerType: 'N',
        },
        data: {
          lines: [
            {
              mtn: line,
              npaNxx: npanxx,
              nonGeoLine,
            },
          ],
        },
      }
    : {
        cartInfo: {
          clientAppName: 'VZW-DOTCOM',
          accountNumber: '',
          cartCreator: '',
          processingMTN: line,
          processStep: 'Accessories',
          processAction: 'AssignNumbers',
          intendType: `${getIntendType()}`,
        },
        data: {
          lines: [
            {
              mtn: line,
              npaNxx: npanxx,
              meaCode: ngp1,
              nonGeoLine,
            },
          ],
        },
      };

  const apiURL = `${getSecureBaseUrl()}${apiUrls().assignNPANXX}`;
  return HttpService.post(apiURL, postData);
};

export const assignNPANXXMTNHP = (npanxx, ngp1) => {
  let postData = {};
  postData = `${getIntendType()}`.includes('NSE')
    ? {
        cartInfo: {
          intendType: 'NSE',
          processingMTN: 'newLine2',
          processStep: 'NumberSelection',
          processAction: 'AssignNumbers',
          customerType: 'N',
        },
        data: {
          lines: [
            {
              mtn: 'newLine2',
              npaNxx: npanxx,
            },
          ],
        },
      }
    : {
        cartInfo: {
          clientAppName: 'VZW-DOTCOM',
          accountNumber: '',
          cartCreator: '',
          processingMTN: 'newLine2',
          processStep: 'NumberSelection',
          processAction: 'AssignNumbers',
        },
        data: {
          lines: [
            {
              mtn: 'newLine2',
              npaNxx: npanxx,
              meaCode: ngp1,
            },
          ],
        },
      };

  const apiURL = `${getSecureBaseUrl()}${apiUrls().assignNPANXX}`;
  return HttpService.post(apiURL, postData);
};

export const visionPending = (visionData) => {
  const data = {
    visionOrderNumber: visionData?.visionData?.visionPendingNumber,
    cartId: '',
    processingMTN: visionData?.visionData?.processingMTN,
    mon: visionData?.visionData?.mon,
    processStep: 'WHWRedemption',
    processAction: 'CancelPendingOrder',
    intent: 'RedemptionAccessory',
    flowType: 'WHW_Redemption',
  };
  const apiURL = `${getSecureBaseUrl()}${apiUrls().visonPendingOrder}`;

  return HttpService.post(apiURL, data);
};

export const getAddonsAPI = () => {
  // const headers = {
  //   "Content-Type": "application/json",
  //   "channelId": 'VZW-DOTCOM',
  //   "x-soe-apikey": "uFWjzl4du5e46whYg73iCGqriX2l62C9"
  // };
  const data = {
    spoCategoryFilters: ['WHOLEHWIFI'],
    redemption: isWHWP2() ? 'Y' : 'N',
    line: isWHWP2()
      ? viewport() === 'mfapp'
        ? getCookie('whwProcessingMTN')
        : getSession('whwProcessingMTN')
      : isJointTransactionFlow()
        ? getJointTransactionLine()
        : 'newLine1',
  };
  const postData = isWHWPhase2Flag() ? data : {};
  const apiURL = `${getSecureBaseUrl()}${apiUrls().addOnsurl}`;
  return HttpService.post(apiURL, postData);
};

/* Action to add Youtube TV to Cart */

export const addYTTVtoCart = (data) => ({
  type: 'ADD_YTTV_TO_CART',
  data,
});

export const addYTTVtoCartAPI = (data) => {
  const postData = {
    cartInfo: {
      cartCreator: '8602350152',
      intendType: 'EUP',
      creditAppNum: null,
      processStep: 'Accessories',
    },
    data: {
      isSubscription: true,
      account: {
        mcsSubscription: {
          remove: [
            {
              itemId: data.skuDetails.productId,
              name: data.displayName,
              description: data.descriptionText,
              pricePlanId: data.pricePlanId,
              price: 64.99,
              contentId: 'YTTVBASIC',
            },
          ],
        },
      },
    },
  };
  // https://soe-hivv-nssit3-bg.ebiz.verizon.com/cartservice/cart/add-features
  const apiURL = `${getSecureBaseUrl()}${apiUrls().cartAddOnurl}`;
  return HttpService.post(apiURL, postData);
};

// Action for Promos

export const getPromos = () => ({
  type: 'GET_PROMOS',
});

export const getPromosFromAEM = () => {
  const apiUrl = apiUrls().getAddonsPromos;

  return axios.get(apiUrl);
};

export const callNPANXXOnHp = (data) => ({
  type: 'GET_NPA_NXX_ON_HP',
  data,
});

export const saveZip = (data) => ({
  type: 'GET_SAVED_ZIP',
  data,
});

export const callAssignMtn = (data) => ({
  type: 'GET_ASSIGNMTN',
  data,
});

export const isNpaCallNeed = (data) => ({
  type: 'NPA_CALL',
  data,
});

export const isHomeLineCall = (data) => ({
  type: 'HOME_LINE_CALL',
  data,
});

export const validateE911Address = (data) => ({
  type: 'VALIDATE_E911',
  data,
});

export const callValidateE911 = (data) => {
  const postData = {
    addressLine1: data.data.addressLine1,
    addressLine2: data.data.addressLine2,
    state: data.data.state,
    city: data.data.city,
    zipCode: data.data.zipCode,
    type: 'e911',
  };
  const apiURL = `${getSecureBaseUrl()}${apiUrls().validateE911Address}`;
  return HttpService.post(apiURL, postData);
};

export const showAddonNotification = (data) => ({
  type: 'SHOW_ADD_NOTIFICATION',
  data,
});

export const setSelectedProduct = (data) => ({
  type: 'SET_SELECTED_PRODID',
  data,
});

export const setSelectedProductName = (data) => ({
  type: 'SET_SELECTED_PRODNAME',
  data,
});

export const setAddonsCount = (data) => ({
  type: Constants.SET_ADDON_COUNT,
  data,
});
